import React from 'react';
import { ProductCardType } from '@loomstateorg/shared-frontend';
import ProductTile, { ProductTileProps } from './index';
import ProductTileCompact from '../product-tile-compact';

export { DEFAULT_CARD_TYPE, ProductCardType } from '@loomstateorg/shared-frontend';

const ProductTileCompactSquare: React.FC<ProductTileProps> = (props) => (
  <ProductTileCompact {...props} imageAspectClassName="aspect-[1/1]" />
);

export const tileRegistry: Record<ProductCardType, React.ComponentType<ProductTileProps>> = {
  [ProductCardType.Classic]: ProductTile,
  [ProductCardType.Compact]: ProductTileCompact,
  [ProductCardType.CompactSquare]: ProductTileCompactSquare,
};
